import type { WorkflowRequest } from '../model';
import { workflowRequestDisplayStatus } from '../models/workflowRequestListModel';
import { StatusBadge } from '../../../design-system';

export const statusLabel: Record<string, string> = {
  DRAFT: '작성 중', PUBLISHED: '게시됨', RETIRED: '이전 버전', IN_PROGRESS: '진행 중',
  EXECUTION_UNVERIFIED: '반영 확인 필요', AWAITING_EFFECTIVE: '시행 대기', COMPLETED: '완료', DENIED: '반려', CANCELLED: '취소', PENDING: '대기', SKIPPED: '생략',
  ACTIVE: '사용 중', ARCHIVED: '보관됨', NEEDS_CHANGES: '보완 필요', RETURNED: '보완 요청',
};
export function Status({ value }: { value: string }) {
  const tone = ['COMPLETED', 'PUBLISHED', 'ACTIVE'].includes(value) ? 'success'
    : value === 'DENIED' ? 'danger'
    : ['NEEDS_CHANGES', 'RETURNED', 'EXECUTION_UNVERIFIED'].includes(value) ? 'warning'
    : ['IN_PROGRESS', 'AWAITING_EFFECTIVE'].includes(value) ? 'info'
    : 'neutral';
  return <StatusBadge tone={tone} label={statusLabel[value] ?? value} />;
}

export function RequestStatus({ request }: { request: Pick<WorkflowRequest, 'status' | 'execution'> }) {
  return <Status value={workflowRequestDisplayStatus(request)} />;
}
